"use strict";
exports.__esModule = true;
exports.ViewMore = void 0;
var ViewMore_1 = require("./ViewMore");
var ViewMoreLoader_1 = require("./ViewMoreLoader");
var ViewMore = Object.assign(ViewMore_1.ViewMore, {
    Loader: ViewMoreLoader_1.ViewMoreLoader
});
exports.ViewMore = ViewMore;
//# sourceMappingURL=index.js.map